import React, { createContext, useState } from 'react';

const CacheContextDomicileMaison = createContext();

export const CacheDomicileMaisonProvider = ({ children }) => {
		const [cache, setCache] = useState(JSON.parse(sessionStorage.getItem("cacheDomicileMaison")) || {});

	const setCacheCustom = () => {
		sessionStorage.setItem("cacheDomicileMaison", JSON.stringify(cache))
	}

	const clearCacheDomicileMaison = () => {
		setCache({})
	}

	return (
		<CacheContextDomicileMaison.Provider value={{ cache, setCache, setCacheCustom, clearCacheDomicileMaison }}>
			{children}
		</CacheContextDomicileMaison.Provider>
	);
};

export default CacheContextDomicileMaison;
